var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.79348 3.26676C2.00835 2.798 2.46414 2.5 2.96875 2.5H17.0329C17.5375 2.5 17.9933 2.798 18.2082 3.26676C18.423 3.73553 18.3579 4.288 18.0389 4.6898L12.0844 12.1733V16.429C12.0844 16.8341 11.863 17.2058 11.5082 17.3866C11.1533 17.5674 10.7333 17.5306 10.4175 17.2862L8.33396 15.679C8.07026 15.4781 7.91725 15.16 7.91725 14.8218V12.1733L1.95952 4.68645C1.64373 4.288 1.57536 3.73218 1.79348 3.26676Z",
    fill: "#4B4D56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.925d021782d258e8a6997ee2336436e8.svg";
export { ForwardRef as ReactComponent };